import { IBioSampleDetails } from "../../models/BioSampleDetails";
import { IChooseApp } from "../../models/ChooseApp";
import { IPersonalInfo } from "../../models/PersonalInfo";
import { IBioSamplesAndTests } from "../../models/BioSamplesAndTests";
import { IlabBioPreference } from "../../models/BioPreference";
import { IFilerInformation } from "../../models/FilerInformation";

export interface IBioRequest {
  labBIOPersonalInfoDetails: IPersonalInfo;
  labBIOChooseAppl: IChooseApp;
  labBIOFilerInfoDetails: IFilerInformation;
  labBIOApplicationDetails: IBioSampleDetails;
  labApplicationchangedDetails?: IBioSampleDetails;
  labChangedPreference?: IlabBioPreference;
  labchangedSampleTestDetails?: IBioSamplesAndTests[];
  labBioSampleTestDetails: IBioSamplesAndTests[];
  labBioPreference: IlabBioPreference;
  applicationNumber?: string;
  actionStatus?: string;
  actionType?: string;
  reasonForCancellation?: string;
  labBioApplicationStatus?: IBIOApplicationStatus;
  submittedFeedback?: number;
  isReportGenerated?: number;
  labReportDetails?: string;
}

export interface IBIOApplicationStatus {
  applicationRequestFor: number;
  miiApplication: number;
  eserviceApplication: number;
  islabapplicationamended?: number;
  islabapplicationcancelled?: number;
  actionedStatus?: string;
  ActionRequest: string;
  amendmentRaisedStage?: number | null;
  islabapplicationDuplicated?: number;
}

export const defBIOAmmendAppStatus: IBIOApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 18,
  eserviceApplication: 14,
  islabapplicationamended: 1,
  ActionRequest: "Amendment request",
};
export const defBIOAmmendRowAppStatus: IBIOApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 30,
  eserviceApplication: 20,
  islabapplicationamended: 1,
  ActionRequest: "Amendment request",
};
export const defBIOCancelAppStatus: IBIOApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 25,
  eserviceApplication: 17,
  islabapplicationcancelled: 1,
  ActionRequest: "Cancel request",
};
export const defBIOAppStatus: IBIOApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 2,
  eserviceApplication: 2,
  ActionRequest: "Application Submitted",
};

export const defBIOExchangeAppStatus: IBIOApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 2,
  eserviceApplication: 2,
  ActionRequest: "Application Submitted",
};
export const defDuplicateAppStatus: IBIOApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 31,
  eserviceApplication: 21,
  islabapplicationDuplicated: 1,
  ActionRequest: "Duplicate request",
};
